import mod from "-!./EcOrder.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./EcOrder.js?vue&type=script&lang=js&external"